import dkAxios from '@/jslib/dk-axios'

// POST: 商品一级分类
export const GetFristCategory = data => dkAxios({
  url: '/v1/cms/Category',
  method: 'GET',
  params: data,
});

// POST: 新增商品分类
export const addCategory = data => dkAxios({
  url: '/v1/cms/Category',
  method: 'POST',
  data,
})

// POST: 编辑商品分类
export const editCategory = data => dkAxios({
  url: `/v1/cms/Category/${data.uuid}`,
  method: 'PUT',
  data,
})

// POST: 删除商品分类
export const delCategory = data => dkAxios({
  url: `/v1/cms/Category/${data}`,
  method: 'DELETE',
})

// POST: 获取商品筛选分类
export const getCategory = data => dkAxios({
  url: '/v1/cms/Product/category',
  method: 'POST',
  params: data,
})

// POST: 获取商品列表
export const getCommodityList = data => dkAxios({
  url: '/v1/cms/Product',
  method: 'GET',
  params: data,
})

// DELETE: 删除商品
export const delCommoddity = data => dkAxios({
  url: `/v1/cms/Product/${data}`,
  method: 'DELETE',
})

// POST: 上下架
export const setStatus = data => dkAxios({
  url: '/v1/cms/Product/statusToggle',
  method: 'POST',
  params: data,
})

// POST: 上新
export const setNewly = data => dkAxios({
  url: '/v1/cms/Product/setNewly',
  method: 'POST',
  data,
})

// POST: 推荐
export const setRecommendation = data => dkAxios({
  url: '/v1/cms/Product/setRecommendation',
  method: 'POST',
  params: data,
})

// POST：获取规格库存列表
export const getStandardList = data => dkAxios({
  url: '/v1/cms/Product/readStandard',
  method: 'POST',
  params: data,
})

// POST：获取商品详情
export const getCommodityDetail = data => dkAxios({
  url: `/v1/cms/Product/${data}`,
  method: 'GET',
})

// POST: 新增商品
export const addCommodity = data => dkAxios({
  url: '/v1/cms/Product',
  method: 'POST',
  data,
})

// POST: 编辑商品
export const editCommodity = data => dkAxios({
  url: `/v1/cms/Product/${data.uuid}`,
  method: 'PUT',
  data,
})

// 积分===================================


// POST: 获取商品列表
export const getPointProductList = data => dkAxios({
  url: '/v1/cms/PointProduct',
  method: 'GET',
  params: data,
})

// DELETE: 删除商品
export const delPointProduct = data => dkAxios({
  url: `/v1/cms/PointProduct/${data}`,
  method: 'DELETE',
})

// POST: 上下架
export const setPointProductStatus = data => dkAxios({
  url: '/v1/cms/PointProduct/statusToggle',
  method: 'POST',
  params: data,
})


// POST：获取商品详情
export const getPointProductDetail = data => dkAxios({
  url: `/v1/cms/PointProduct/${data}`,
  method: 'GET',
})

// POST: 新增商品
export const addPointProduct = data => dkAxios({
  url: '/v1/cms/PointProduct',
  method: 'POST',
  data,
})

// POST: 编辑商品
export const editPointProduct = data => dkAxios({
  url: `/v1/cms/PointProduct/${data.uuid}`,
  method: 'PUT',
  data,
})

export const fileImport = data => dkAxios({
  url: '/v1/cms/Product/import',
  method: 'POST',
  data,
})


export const getExportUrl = data => dkAxios({
  url: '/v1/cms/Product/export',
  method: 'GET',
  params: data,
})

export const getBrand = () => dkAxios({
  url: '/v1/cms/Brand?page_size=1000&pageIndex=1',
  method: 'GET',
})



// WEBPACK FOOTER //
// ./src/api/commodity.js